"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_CONFIRM_SCHEDULE_CONTENT = void 0;
exports.CREDIT_BUILDER_CONFIRM_SCHEDULE_CONTENT = {
    HEADER: 'Finalize your payment schedule',
    SUB_HEADER: 'We’ll start rent payment beginning with your {{month}} bill.',
    SCHEDULE: {
        TITLE: 'You’ll pay Flex each month',
        BP_DISCLAIMER: 'Since it’s after the {{repaymentOrdinal}} of the month, we’ll collect your payment and pay rent to your property right after you finish signing up.'
    },
    PAYMENT_METHOD_TITLE: 'Payment method',
    AUTHORIZATION: 'I authorize Flex to charge my card according to this payment schedule and understand that the amounts are estimates and may vary.',
    CTA: 'Continue'
};
